import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';

export type Language = 'en' | 'de';

/** Shown in their own language, which is the convention every multilingual product follows —
 *  someone looking for German is looking for the word "Deutsch". */
export const LANGUAGES: { code: Language; label: string }[] = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
];

const STORAGE_KEY = 'crm-lang';

export function readStoredLanguage(): Language {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'en' || stored === 'de') return stored;
  // No stored choice: follow the browser. A German-speaking colleague should not have to find
  // the switcher on first load.
  return navigator.language?.toLowerCase().startsWith('de') ? 'de' : 'en';
}

export function setLanguage(language: Language): void {
  void i18n.changeLanguage(language);
  localStorage.setItem(STORAGE_KEY, language);
  document.documentElement.lang = language;
}

export function currentLanguage(): Language {
  return i18n.resolvedLanguage === 'de' ? 'de' : 'en';
}

const initial = readStoredLanguage();

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, de: { translation: de } },
  lng: initial,
  fallbackLng: 'en',
  interpolation: {
    // React escapes for us; i18next's own escaping would mangle user text such as "Beispiel
    // GmbH & Co. KG" into "&amp;".
    escapeValue: false,
  },
  returnNull: false,
});

document.documentElement.lang = initial;

export default i18n;
